<template>
  <div class="padded">

<!--
    <el-row type="flex">
      <el-col :span="24" align="center">

      <request-action
       ref="rtx"
       v-if="rowData && rowData.actionType && rowData.actionType.startsWith('RT')"
       :site-id="siteId ? siteId : rowData.site_id"
       :org-id="rowData.organisation_id"
       :type="rowData.actionType"
       :adding="false"
       :row-data="rowData">
    </request-action>

    <ticket-action
      ref="tic"
      v-if="rowData.actionType==='COMPLAINT'"
      :showText="true"
      :row-data="rowData"
      size="small"
     :site-id="siteId"
     :org-id="rowData.organisation_id"
     :ticket-id="rowData.ticket_id" />

    <permit-workflow-action
      :ref="permitLabel"
      v-if="rowData.actionType===permitLabel"
      :showText="true"
      :row-data="rowData"
      size="small"
      :site-id="siteId"
      :org-id="rowData.organisation_id" />

    </el-col>
  </el-row>
-->
    <el-col align="left">

    <edit-pane
      v-if="!hidePanel"
      ref="ep"
      prefix="Action: "
      :title="form.summary"
      :is-edit="this.editMode"
      @save="onSave"
      @cancel="onCancel"
      @edit="onEdit"
      @add="onSave" />

    <el-form ref="actionDetailsForm" :model="form" label-width="120px">

      <el-row :gutter="12">
        <el-col :sm="24" :md="mdreq" :lg="lgreq">
        <div v-if="this.isTowerCo() && !type">
            <select-action-type v-model="form.actionType" :disabled="disabled" @change="check" />
            &nbsp;
        </div>

          <div v-else>
            <el-form-item label="Action Type">
              <b>{{this.form.actionType}}</b>
            </el-form-item>
          </div>
        </el-col>


          <section v-if="isRequest">

            <el-col :sm="24" :md="mdreq" :lg="lgreq">

              <select-sharer v-if="isTowerCo()"
                label=""
                :placeholder="isBackhaul ? 'Backhaul Customer' : 'Sharer'"
                v-model="form.organisation_id"
                :limit="form.actionType != 'RTS' ? (limits && limits.length === 0 ? null : limits) : null"
                :disabled="disabled" @change="check" />

            </el-col>

            <el-col v-if="isBackhaul && (isTowerCo() || isTelco())" :sm="24" :md="mdreq" :lg="lgreq">

              <switch-input
                  v-model="isProvider"
                  on-text="Provider"
                  off-text="Customer"
                  :disabled="disabled" />

            </el-col>

            <el-col v-if="isBackhaul" :sm="24" :md="mdreq" :lg="lgreq">

              <select-backhaul-provider
                  v-if="isBackhaul && (isProvider || isBackhaulCo())"
                  label="Provider"
                  v-model="form.provider_id"
                  placeholder="Select Backhaul Provider"
                  :disabled="disabled || isBackhaulCo()"
                  @change="check" />

                <select-backhaul-type
                 v-if="(isBackhaul && isProvider) || isBackhaulCo()"
                 v-model="form.backhaulType" />
            </el-col>

            <el-col v-if="isBackhaul && isProvider" :sm="24" :md="mdreq" :lg="lgreq">

              <check-box
                  v-model="isExcl"
                  :disabled="disabled">
                  Show only sites by provider
              </check-box>

            </el-col>

            <el-col :sm="24" :md="mdreq" :lg="lgreq">
              <select-sharer v-if="isBackhaulCo()"
                v-model="form.organisation_id"
                :disabled="disabled" @change="check" />
            </el-col>
        </section>

      </el-row>

      <select-site
        ref="selectSite"
        v-if="showSiteSelect"
        v-model="form.site_id"
        :show-warning="true"
        :sharer="(isTelco() ? org().id : (isBackhaulCo() ? null : form.organisation_id))"
        :provider="(form.actionType === 'RTB') ? (isExcl ? form.provider_id : null) : null"
        :backhaul-search="(form.actionType === 'RTB')"
        :action-type="form.actionType.startsWith('RT') ? form.actionType : null"
        :exclude-sharer="(form.actionType === 'RTS')"
        :callback="successSite"
        :disabled="!(isProvider ? form.provider_id && form.organisation_id : isBackhaulCo() ? true : form.organisation_id)"
        @change="check" />

      <el-row style="padding-top: 1em;">
        <el-col v-if="isTowerCo()" :sm="24" :md="12" :lg="8">
          <date-input label="Actual Date" v-model="form.actualDate" :disabled="disabled" />
        </el-col>

        <el-col :sm="24" :md="12" :lg="isTelco() ? 12 : 8">
          <date-input label="Target Date" v-model="form.targetDate" :disabled="disabled" />
        </el-col>

        <el-col :sm="24" :md="12" :lg="isTelco() ? 12 : 8">
          <select-priority v-model="form.priority" :disabled="disabled" @change="check" />
        </el-col>

      </el-row>

      <text-input v-if="isTowerCo()" label="Summary" prop="summary" v-model="form.summary" :disabled="disabled" placeholder="Summary of action" style="padding-top: 0.5em;" />

      <el-form-item v-if="isTowerCo()" prop="remarks" label="Remarks">
        <el-input type="textarea" :rows="3" v-model="form.remarks" :disabled="disabled" />
      </el-form-item>

    </el-form>

    <el-col v-if="form && form.updated_at" align="right" :span="24">
      <span class="pull-right">Last update: <b>{{formatFriendlyDate(form.updated_at)}}</b> ({{formatDateTime(form.updated_at)}})<span v-if="form.updated_by"> by {{form.updated_by}}</span></span>
    </el-col>

  </el-col>
</div>

</template>


<script>

import Vue from 'vue'
import VueEvents from 'vue-events'
Vue.use(VueEvents)

import {DATETIME_SQL_FORMAT, ENABLE_SAVE_EVENT, DISABLE_SAVE_EVENT, settings} from '@/components/Data'

import SiteMixins from '@/mixins/SiteMixins'

import RequestAction from '@/components/actions/RequestAction'
import ProgressWorkflowAction from '@/components/actions/ProgressWorkflowAction'

import RenewalAction from '@/components/actions/RenewalAction'
import TicketAction from '@/components/actions/TicketAction'


import AcquireRequest from '@/components/requests/acquire/AcquireRequest'

import SelectActionType from '@/components/atoms/selects/SelectActionType'

import SelectBackhaulType from '@/components/atoms/selects/SelectBackhaulType'
import SelectBackhaulProvider from '@/components/atoms/selects/SelectBackhaulProvider'

import SelectPriority from '@/components/atoms/selects/SelectPriority'

import SelectSharer from '@/components/atoms/selects/SelectSharer'

export default {

  components: {
    AcquireRequest,
    SelectActionType,
    SelectBackhaulType,
    SelectBackhaulProvider,
    SelectPriority,
    SelectSharer,
    RenewalAction,
    RequestAction,
    ProgressWorkflowAction,
    TicketAction
  },

  mixins: [SiteMixins],

  props: {
    rowData: {
      type: Object,
      default: null
    },
    siteId: {
      type: Number,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    editMode: {
      type: Boolean,
      default: false
    },
    tableRef: {
      type: String,
      default: 'action-table'
    },
    adding: {
      type: Boolean,
      default: false
    },
    hidePanel: {
      type: Boolean,
      default: false
    }
  },

  watch: {
    isProvider: function (data) {
      this.siteData = null
    }
  },



  methods: {

    getSharerIds (sharerIds) {
      this.limits = sharerIds
    },


    resetData () {
      this.form.actionType = this.type
      this.form.organisation_id = null
      this.form.summary = null
      this.form.site_id = this.siteId
      this.clearSiteInfo()
    },


    success (response) {

      if (this.isBackhaul && this.isProvider && this.isAdding) {
        let bp = {
          site_id: this.form.site_id,
          provider_id: this.isBackhaulCo() ? this.org().id : this.form.provider_id,
          backhaulType: this.form.backhaulType,
          status: 'Pending'
        }

        this.saveForm(this, '/backhaul', null, bp, 'Backhaul Provider')
      }

      this.$events.fire(this.tableRef + '-refresh-table')

      if (this.isAdding) {
        this.resetData()
      }

      this.$emit('update-stats')
    },


    successSite (siteId, siteName, data) {

      if (data) {
        delete data.stats
        delete data.landowner
//        delete data.backhaul
//        delete data.sharers
      }

      this.siteName = siteName
      this.siteData = data
      this.form.site_id = siteId
/*
      @BUG OK for first site selected, not updated second,third sites, etc.

      if (!this.form.summary) {
        this.form.summary = this.form.actionType + ': for ' + this.siteName
      }
*/
      this.check()
    },


    clearSiteInfo () {
      this.siteName = null
      this.form.site_id = null
      this.form.summary = null
      this.siteData = null
    },


    onCancel () {
      this.disabled = true
      this.resetData()
    },


    onEdit () {
      this.disabled = false
    },


    onAdd () {
      this.disabled = false
      this.onSave()
    },


    onSave () {

      if (!this.form.summary || this.form.summary === '') {
        if (this.form.actionType) {
          this.form.summary = this.form.actionType
        }


        if (this.site && this.site.siteName) {

          this.form.summary = this.form.actionType + ' for ' + this.site.siteName

        } else {

          if (this.form.organisation_id && this.$refs.selectOrg) {
            this.form.summary = this.form.summary + ' for ' + this.$refs.selectOrg.selected.currentLabel
          }

        }

      }


      if (this.isBackhaul) {
        this.form.subActionType = (this.isProvider ? 'PROV' : 'CUST')
      }


      if (!this.form.actualDate) {
        this.form.actualDate = new Date()
      }

      if (!this.form.targetDate) {
        this.form.targetDate = this.addDateTime(new Date(), 14, 'day', DATETIME_SQL_FORMAT)
      }


      this.form.status = (this.isTelco() || this.isBackhaulCo()) ? 'NEW' : (this.form.status ? this.form.status : 'Pending')

      if (!this.form.organisation_id && this.isTelco()) {
        this.form.organisation_id = this.org().id
      }

      this.form.targetDate = this.formatDateSql(this.form.targetDate)
      this.form.actualDate = this.formatDateSql(this.form.actualDate)

      this.saveForm(this, '/actions', this.form.id, this.form, this.form.summary, this.success)

      if (this.adding) {
        this.disabled = false
      } else {
        this.disabled = true
      }

      //      this.resetData()
    },


    onClose () {
      this.resetData()
    },


    check (data) {
      if (this.form.actionType) {
        if (this.form.actionType.startsWith('RT')) {

          if (this.form.organisation_id && this.form.site_id) {
            return this.$events.fire(ENABLE_SAVE_EVENT)
          }

        } else {

          if (this.form.site_id) {
            return this.$events.fire(ENABLE_SAVE_EVENT)
          }

        }
      }

      this.$events.fire(DISABLE_SAVE_EVENT)
    }

  },

  computed: {
    isRequest: function () {
      return this.form.actionType && this.form.actionType.startsWith('RT')
    },

    isAcquire: function () {
      return this.form.actionType && this.form.actionType.startsWith('RTA')
    },

    isBackhaul: function () {
      return this.form.actionType && this.form.actionType.startsWith('RTB')
    },

    mdreq: function () {
      return this.isBackhaul ? 8 : 12
    },

    lgreq: function () {
      return this.isBackhaul ? 8 : 12
    }

  },


  data () {
    return {
      disabled: true,
      permitLabel: settings.permitLabel,
      isAdding: this.adding,
      isProvider: false,
      isExcl: true, // was false.
      siteName: null,
      siteData: null,
      showSiteSelect: !this.siteId,
      form: this.adding ? this.getTableStruct('actions') : this.rowData,
      limits: null
    }
  },


  created () {

    if (this.rowData && this.rowData.id) {
      this.fetchData('/sites/sharer-ids/' + this.rowData.id, this.getSharerIds)
    }

    if (this.adding) {

      this.disabled = false

      this.form.actionType = this.type ? this.type : null
      this.form.backhaulType = (this.form.actionType === 'RTB' ? 'Fibre' : null)

      this.form.site_id = this.siteId

      delete this.form.id

//      console.log('request form', this.form)


      if (!this.form.actualDate) {
        this.form.actualDate = new Date()
        this.form.priority = 'Medium'
      }

      if (this.form.actualDate && !this.form.targetDate) {
        this.form.targetDate = new Date(Date.now() + 12096e5) // 14 days in milliseconds
      }

    }


    if (!this.form.site_id && this.siteId) {
      this.form.site_id = this.siteId
    }


    if (!this.form.organisation_id) {
      this.form.organisation_id = this.isTelco() ? this.org().id : (this.sharer ? this.sharer : null)
    }

    if (!this.form.provider_id) {
      this.form.provider_id = this.isBackhaulCo() ? this.org().id : null
    }


    if (this.adding && !this.siteData && this.rowData && this.rowData.siteName) {
      this.siteData = this.rowData
    }

    if (this.form.site_id) {
      this.showSiteSelect = false
    }

    if (!this.siteId && this.isRequest && this.adding) {
      this.$events.fire(DISABLE_SAVE_EVENT)
    }

//    console.log('siteId', this.siteId, this.showSiteSelect)
//    console.log('siteId', this.siteId, 'form', this.form, 'rowData', this.rowData)
//  console.log('ActionDetails:', 'adding? ', this.adding, 'sharer:', this.sharer, this.form.organisation_id)

  }
}

</script>

<stype scoped>
  .el-select {display: inline-block; width: 100%;}
</style>
